<div class="header-container">
  <div class="header-user-profile pull-right" *ngIf="profile">

    <ng-container class="pull-right">
      <button mat-menu-item [matMenuTriggerFor]="companyMenu" class="pull-right"
        style="width: 200px; font-family: 'DM Sans', sans-serif; font-size: 16px;">
        <mat-label class="float-end">{{companies[activeCompany].name}}</mat-label>
      </button>
      <mat-menu #companyMenu="matMenu" xPosition="after">
        <button mat-menu-item *ngFor="let company of companies; let i = index" [value]='i' (click)="onCompanyOpen(i);"
          style="min-width: 200px; font-family: 'DM Sans', sans-serif;  font-size: 16px;">
          {{company.name}}
        </button>
      </mat-menu>
    </ng-container>

    <ng-container>
      <button mat-menu-item [matMenuTriggerFor]="notificationsMenu" style="width:40px; padding: 0;">
        <span class="notification-badge-container">
          <mat-icon style="vertical-align: bottom;">notifications</mat-icon>
          <span class="badge badge-pill badge-danger notification-badge" style="color: white; font-size: 9px;"
            *ngIf="unreadNotificationsCount > 0">
            {{unreadNotificationsCount}}
          </span>
        </span>
      </button>
      <mat-menu #notificationsMenu="matMenu" class="notification-menu" xPosition="after">
        <div class="notification-preview">
          Notificaciones
        </div>
        <div class="notification-preview" *ngIf="!(notifications?.length > 0)">
          - sin notificaciones -
        </div>
        <div class="notification-preview" *ngFor="let notification of notifications"
          [ngClass]="{'notification-unread': !notification.read}" (click)="read(notification)">
          <div class="notification-left">
            <div>
              <div class="notification-title">{{notification.title}}</div>
              <div class="notification-message">{{notification.message}}</div>
            </div>
          </div>
          <div class="notification-right">
            <mat-icon class="notification-icon small">
              {{notification.read ? 'drafts' : 'mark_email_unread'}}
            </mat-icon>&nbsp;&nbsp;&nbsp;&nbsp;
            <ng-container *ngIf="notification.days > 1">{{notification.days}}&nbsp;días</ng-container>
            <ng-container *ngIf="notification.days == 1">1&nbsp;día</ng-container>
            <ng-container *ngIf="!(notification.days > 0)">
              {{notification.createdAt | date:'HH:mm'}}hs
            </ng-container>
          </div>
        </div>
      </mat-menu>

    </ng-container>

    <ng-container>
      <button mat-menu-item style="width:40px; padding: 0;" (click)="openWhatsapp()">
        <mat-icon style="vertical-align: center;">help_outline</mat-icon>
      </button>
    </ng-container>

    <ng-container>
      <button mat-menu-item style="width:40px; padding: 0;" (click)="openAccount()">
        <mat-icon style="vertical-align: center;">settings</mat-icon>
      </button>
    </ng-container>

    <ng-container>
      <button mat-menu-item [matMenuTriggerFor]="profileMenu" style="width:40px; padding: 0;">
        <mat-icon class="text-lilac-manax">account_circle</mat-icon>
      </button><br>
      <mat-menu #profileMenu="matMenu" xPosition="before">
        <button mat-menu-item (click)="openAccount()" style="width: 200px;">
          <mat-icon>account_circle</mat-icon> Mi Cuenta
        </button>
        <button mat-menu-item (click)="openCompanySettings()" style="width: 200px;" *ngIf="isAdmin || isManax">
          <mat-icon>tune</mat-icon> Preferencias
        </button>
        <button mat-menu-item (click)="logout()" style="width: 200px;">
          <mat-icon>logout</mat-icon> Salir
        </button>
      </mat-menu>
    </ng-container>

  </div>
</div>